import { useQuery } from "@tanstack/react-query";
import useCompanyIdFromUrl from "@/hooks/companies/useCompanyIdFromUrl";
import apiClient from "@/modules/request.module.v2";

import * as constants from "/shared/constants";

export default (resourceKey, permission) => {
  const companyId = useCompanyIdFromUrl();

  const resource = constants[resourceKey];

  if (!resource || !permission) {
    throw new Error(
      "useAclIsAllowed: Resource and permission must be provided",
    );
  }

  return useQuery({
    enabled: !!companyId,
    queryKey: ["useIsAllowed", resource, permission, companyId],
    queryFn: () => {
      return apiClient.get(
        `permissions/acl/is-allowed?resource=${resource}&permission=${permission}`,
        {
          headers: {
            "x-company-id": companyId,
          },
        },
      );
    },
  });
};
